export default __webpack_public_path__ + "static/media/support-rules.c3c1bcfa.yaml";